import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import '../../../../motion-utils/dist/es/errors.mjs';
import { noop } from '../../../../motion-utils/dist/es/noop.mjs';
import { useContext, useRef, useInsertionEffect } from 'react';
import { animateValue } from '../animation/animators/MainThreadAnimation.mjs';
import { MotionConfigContext } from '../context/MotionConfigContext.mjs';
import { useConstant } from '../utils/use-constant.mjs';
import { useIsomorphicLayoutEffect } from '../utils/use-isomorphic-effect.mjs';
import { useMotionValue } from './use-motion-value.mjs';
import { isMotionValue } from './utils/is-motion-value.mjs';
import { frame } from '../frameloop/frame.mjs';
function useSpring(source) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useContext = useContext(MotionConfigContext),
    isStatic = _useContext.isStatic;
  var activeSpringAnimation = useRef(null);
  var initialValue = useConstant(function () {
    return isMotionValue(source) ? source.get() : source;
  });
  var unit = useConstant(function () {
    return typeof initialValue === "string" ? initialValue.replace(/[\d.-]/g, "") : undefined;
  });
  var value = useMotionValue(initialValue);
  var latestValue = useRef(initialValue);
  var latestSetter = useRef(noop);
  var startAnimation = function startAnimation() {
    stopAnimation();
    activeSpringAnimation.current = animateValue(_objectSpread(_objectSpread({
      keyframes: [asNumber(value.get()), asNumber(latestValue.current)],
      velocity: value.getVelocity(),
      type: "spring",
      restDelta: 0.001,
      restSpeed: 0.01
    }, config), {}, {
      onUpdate: latestSetter.current
    }));
  };
  var stopAnimation = function stopAnimation() {
    if (activeSpringAnimation.current) {
      activeSpringAnimation.current.stop();
    }
  };
  useInsertionEffect(function () {
    return value.attach(function (v, set) {
      if (isStatic) return set(v);
      latestValue.current = v;
      latestSetter.current = function (latest) {
        return set(parseValue(latest, unit));
      };
      frame.postRender(startAnimation);
      return value.get();
    }, stopAnimation);
  }, [JSON.stringify(config)]);
  useIsomorphicLayoutEffect(function () {
    if (isMotionValue(source)) {
      return source.on("change", function (v) {
        return value.set(parseValue(v, unit));
      });
    }
  }, [value, unit]);
  return value;
}
function parseValue(v, unit) {
  return unit ? v + unit : v;
}
function asNumber(v) {
  return typeof v === "number" ? v : parseFloat(v);
}
export { useSpring };